import { getAppInstance } from '/@/store/session/selectors';
import { getCampaignString } from '/@/utils';

export const getCarbonCalculatorEnabled = (state) => getAppInstance(state).enableCarbonCalculator;

export const getCampaignsOptions = () => {
    const date = new Date();
    const actualYear = date.getFullYear();
    const lastYearFrom = actualYear - 11;
    const lastYearTo = actualYear + 8;
    const campaigns = [];
    for (let year = lastYearFrom; year <= lastYearTo; year++) {
        campaigns.push({ label: getCampaignString(year), value: year });
    }
    return campaigns;
};

export const getCampaignFrom = (state) => state.carbonCalculator.campaignFrom;

export const getCampaignTo = (state) => state.carbonCalculator.campaignTo;

export const getSelectedCampaigns = (state) => state.carbonCalculator.selectedCampaigns;

export const getFarmingOptions = (state) => state.carbonCalculator.allFarmingTypes;
export const getSelectedFarmingOption = (state) => state.carbonCalculator.farmingType;

// The API already leaves out soil types without values (keeping "Otros").
export const getAllSoilTypesOptions = (state) => state.carbonCalculator?.allSoilTypes;
export const getSoilType = (state) => state.carbonCalculator.soilType;

export const getCrops = (state) => state.carbonCalculator.crops;

export const getClay = (state) => state.carbonCalculator.clay;
export const getOrganicMaterial = (state) => state.carbonCalculator.organicMaterial;
export const getDensity = (state) => state.carbonCalculator.density;

export const getRequiredFieldsComplete = (state) => {
    const { campaignFrom, campaignTo, farmingType, soilType, clay, density, organicMaterial } = state.carbonCalculator;
    return !!campaignFrom && !!campaignTo && !!farmingType && !!soilType && !!clay && !!density && !!organicMaterial;
};

export const getCalculationResult = (state) => state.carbonCalculator.calculationResult;
